import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { config } from '@fortawesome/fontawesome-svg-core';
import "@fortawesome/fontawesome-svg-core/styles.css";
import styles from './profile-card.module.scss';
config.autoAddCss = false;

const renderProfileImage = imageUrl => {
  if (imageUrl) {
    return <img src={imageUrl.publicURL} alt={imageUrl.name} />;
  } else {
    return (
      <div className={styles.placeholder}>
        <FontAwesomeIcon color="#6b6b6b" icon={faUser} size="6x" />
      </div>
    );
  }
};

const ProfileCard = (props) => {
  const breakpoints = useBreakpoint();

  const config = {
    width: breakpoints.mobile ? props.mobile.size : props.desktop.size,
    height: breakpoints.mobile ? props.mobile.size : props.desktop.size,
  };

  return (
    <div className={styles.container} style={{ width: config.width }}>
      
      <div className={styles.photo} style={{ width: config.width, height: config.height }}>
        {
          renderProfileImage(props.imageUrl)
        }
      </div>

      <h1 className={styles.name}>{props.name}</h1>

      <p className={styles.profession}>{props.profession}</p>
    </div>
  );
};

export default ProfileCard;

ProfileCard.defaultProps = {
  imageUrl: null,
  name: 'John Doe',
  profession: 'Not specified',
  desktop: {
    size: 255,
  },
  mobile: {
    size: 158,
  },
};

ProfileCard.propTypes = {
  name: PropTypes.string,
  profession: PropTypes.string,
  imageUrl: PropTypes.shape({
    name: PropTypes.string,
    publicURL: PropTypes.string,
  }),
  desktop: PropTypes.shape({
    size: PropTypes.number,
  }),
  mobile: PropTypes.shape({
    size: PropTypes.number,
  }),
};
